import { render, staticRenderFns } from "./FTB.vue?vue&type=template&id=636354ca"
import script from "./FTB.vue?vue&type=script&lang=js"
export * from "./FTB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports